import { Description, Form, FormButton, Title, Wrapper } from '../../style';

import Input from '../../../../components/Input';

const NewPassword = () => {
  return (
    <Wrapper>
      <Title>New Password</Title>
      <Description textAlign="left">
        In order to protect your account, make sure your <strong>password</strong>:
        <ul>
          <li>
            <strong>•</strong> Is longer than 7 characters
          </li>
          <li>
            <strong>•</strong> Does not match or significiantly contain your username, e.g. do not
            use <code>‘username123’</code>
          </li>
          <li>
            <strong>•</strong> Is not a member of this list of common passwords
          </li>
        </ul>
      </Description>

      <Form>
        <Input label="Password" placeholder="Type your password" type="password" />
        <Input label="Confirm your password" placeholder="Type your password" type="password" />
        <FormButton maxWidth={true}>Change Password</FormButton>
      </Form>
    </Wrapper>
  );
};

export default NewPassword;
